import { FaHiking, FaCampground, FaCalendarAlt, FaUsers } from 'react-icons/fa';

const counter = [
    {
        id: 1,
        icon: <FaHiking />, // Hiking icon
        title: 'Hiking Trails',
        count: '100',
    },
    {
        id: 2,
        icon: <FaCampground />, // Campground icon
        title: 'Camping Sites',
        count: '500',
    },
    {
        id: 3,
        icon: <FaCalendarAlt />, // Calendar icon
        title: 'Years of Operation',
        count: '30',
    },
    {
        id: 4,
        icon: <FaUsers />, // Users icon
        title: 'Community Members',
        count: '2000',
    },
];

export default counter;